<template>
  <li class="dropdownItem dropdownItem__mobilePay">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      行動支付
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/mobilePay'"
          v-if="permissionMobilePayment"
        >
          行動支付表單
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/pregnantService'"
          v-if="IsShowPregnantService()"
        >
          孕婦乘車
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import { hasTeamRole } from '@/utils/teamRoleAuth'

export default {
  props: ['permissionMobilePayment'],

  methods: {
    IsShowPregnantService() {
      // 使用 teamRoles 權限檢查
      return hasTeamRole('pregnant_ride')
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownMobilePay.vue